<template>
  <div id="map" ref="map"></div>
</template>

<script>
import appkey from '@/common/config.js';

let map = null;

export default {
  name: 'shop-map',
  props: {
    name: String,
    lat: Number,
    lng: Number,
    isDraggable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      size: {
        width: '100%',
        height: '100%',
      },
      level: 1,
    };
  },
  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
      // this.relayout();
    } else {
      const script = document.createElement('script');
      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${appkey.kakaoAppKey}`;
      /* global kakao */
      script.onload = () => kakao.maps.load(this.initMap);
      document.head.appendChild(script);
    }
  },
  methods: {
    initMap() {
      const container = this.$refs.map;
      container.style.width = this.size.width;
      container.style.height = this.size.height;

      // 마커의 이미지정보를 가지고 있는 마커이미지를 생성
      // const imageSrc = require('@/assets/');
      // const imageSize = new kakao.maps.Size(24, 35);
      // const markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize);

      // 주소의 경도 위도 정보 가져오기
      const coords = new kakao.maps.LatLng(this.lat, this.lng);

      // 동적지도
      this.loadDynamicMap(container, coords);

      // 정적지도
      // this.loadStaticMap(container, coords);
    },
    loadDynamicMap(container, coords) {
      const marker = new kakao.maps.Marker({
        position: coords, // 마커의 위치
        // image: markerImage,
      });

      const mapOption = {
        center: coords,
        level: this.level,
        draggable: this.isDraggable, // 지도이동
        marker: marker,
      };

      this.map = new kakao.maps.Map(container, mapOption);
      marker.setMap(this.map);

      // 마커 인포윈도우 생성
      // const content = `<div style="padding: 0.5rem; font-weight: bold; text-align: center;">${this.name}</div>`;

      // const infowindow = new kakao.maps.InfoWindow({
      //   content: content,
      // });

      // infowindow.open(map, marker);
      // this.map = map;
    },
    loadStaticMap(container, coords) {
      const marker = [
        {
          position: coords,
          // text: this.name,
        },
      ];

      const mapOption = {
        center: coords,
        level: this.level,
        marker: marker,
      };

      const map = new kakao.maps.StaticMap(container, mapOption);
      this.map = map;
    },
    relayout() {
      this.map.relayout();
    },
  },
};
</script>
